module.exports = __webpack_public_path__ + "static/media/workspace-content.ac0a61e0.svg";